"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AbstractComponent_1 = __importDefault(require("./AbstractComponent"));
var constants_1 = require("../data/constants");
var QuickMessage = /** @class */ (function (_super) {
    __extends(QuickMessage, _super);
    function QuickMessage() {
        var _this = _super.call(this, constants_1.DATA_QUICKMESSAGE) || this;
        _this.COOKIE_NAME = 'closedMessage';
        if (!_this.getElement())
            return _this;
        _this.closeMessage = _this.getChildElement("[".concat(constants_1.DATA_QUICKMESSAGE_CLOSE, "]"));
        _this.quickMessageId = _this.getElement().getAttribute(constants_1.DATA_QUICKMESSAGE);
        _this.initEventListeners();
        _this.checkCookie(_this.quickMessageId);
        _this.setBodyOffset();
        return _this;
    }
    QuickMessage.prototype.initEventListeners = function () {
        var _this = this;
        this.closeMessage.addEventListener('click', function () {
            _this.setCookie("".concat(_this.COOKIE_NAME).concat(_this.quickMessageId), _this.quickMessageId, 365);
        });
    };
    QuickMessage.prototype.setBodyOffset = function () {
        var body = document.querySelector('body');
        var header = body.querySelector("[".concat(constants_1.DATA_HEADER, "]"));
        var headerHeight = header.clientHeight;
        var headerMargin = parseInt(window.getComputedStyle(header).marginBottom);
        var bodyOffset = "".concat(headerHeight + headerMargin);
        body.style.paddingTop = bodyOffset + 'px';
    };
    QuickMessage.prototype.setCookie = function (cookieName, cookieValue, exdays) {
        var date = new Date();
        date.setTime(date.getTime() + (exdays * 24 * 60 * 60 * 1000));
        document.cookie = "".concat(cookieName, "=").concat(cookieValue, ";expires=").concat(date.toUTCString());
        this.hideMessage();
        this.setBodyOffset();
    };
    QuickMessage.prototype.checkCookie = function (id) {
        document.cookie.includes("".concat(this.COOKIE_NAME).concat(id)) ? this.hideMessage() : this.showMessage();
    };
    QuickMessage.prototype.showMessage = function () {
        this.getElement().classList.remove('d-none');
    };
    QuickMessage.prototype.hideMessage = function () {
        this.getElement().classList.add('d-none');
    };
    return QuickMessage;
}(AbstractComponent_1.default));
exports.default = QuickMessage;
